import { render, staticRenderFns } from "./MerchantGroup.vue?vue&type=template&id=2d687b5b"
import script from "./MerchantGroup.vue?vue&type=script&lang=js"
export * from "./MerchantGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports